var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"enrolling-exam-write-student-list"},[_c('PlatDataGridSiteUnit',{attrs:{"grid-id":"PeEnrollExamWriteStudent","show-label":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }